<template>
  <div class="audio-control" ref="control">
    <div class="audio-control-title">{{ title }}</div>
    <!--<div class="audio-control-desc">{{hasBuy ? '' : '购买后即可立即学习哦~'}}</div>-->

    <!--<div class="audio-control-main">-->
    <!--<div class="audio-control-line"-->
    <!--@touchstart="touchstart($event)"-->
    <!--@touchmove="touchmove($event)"-->
    <!--@touchend="touchend($event)"-->
    <!--@mousedown="touchstart($event)"-->
    <!--@mousemove="touchmove($event)"-->
    <!--@mouseup="touchend($event)">-->
    <!--<div class="audio-control-line-box" ref="line">-->
    <!--<div class="audio-control-line-buffered"-->
    <!--:style="{width: bufferedPercent}"></div>&lt;!&ndash; 缓存 &ndash;&gt;-->
    <!--<div class="audio-control-line-current"-->
    <!--:style="{width: currentPercent}">-->
    <!--<div class="timer"-->
    <!--:class="{ 'flr': isTimerRight }"></div>-->
    <!--</div>&lt;!&ndash; 进度 &ndash;&gt;-->
    <!--</div>-->
    <!--</div>-->

    <!--</div>-->
    <div class="audio-control-time">
      <!-- <span>{{ formatSeconds(currentTime) }}</span> -->
      <div
        class="audio-control-line"
        @touchstart="touchstart($event)"
        @touchmove="touchmove($event)"
        @touchend="touchend($event)"
        @mousedown="touchstart($event)"
        @mousemove="touchmove($event)"
        @mouseup="touchend($event)"
      >
        <div class="audio-control-line-box" ref="line">
          <div
            class="audio-control-line-buffered"
            :style="{ width: bufferedPercent }"
          ></div>
          <!-- 缓存 -->
          <div
            class="audio-control-line-current"
            :style="{ width: currentPercent }"
          ></div>
          <div
            class="timer"
            :class="!isSeepWidth ? 'initalDistance' : ''"
            @touchstart="touchstart($event)"
            @touchmove="touchmove($event)"
            @touchend="touchend($event)"
            @mousedown="touchstart($event)"
            @mousemove="touchmove($event)"
            @mouseup="touchend($event)"
            :style="!isSeepWidth ? { left: currentPercent } : { right: 0 }"
          >
            <div class="currentTime">
              {{ formatSeconds(currentTime) }}/{{ formatSeconds(duration) }}
            </div>
            <div class="show-current-time" v-show="speedShowTime">
              {{ formatSeconds(currentTime) }}/{{ formatSeconds(duration) }}
            </div>
          </div>
          <!-- 进度 -->
        </div>
      </div>
      <!-- <span>{{ formatSeconds(duration) }}</span> -->
    </div>
    <div class="audio-control-button">
      <div
        class="audio-control-button-loop"
        v-if="playingStatusType !== ''"
        @click="switchPlayingStatusType"
      >
        <img
          class="list-loop"
          src="../../../assets/images/audio-list-loop.png"
          v-show="playingStatusType == 2"
        />
        <img
          class="odd-loop"
          src="../../../assets/images/odd-loop.png"
          v-show="playingStatusType == 3"
        />
        <img
          class="order-play"
          src="../../../assets/images/order-play.png"
          v-show="playingStatusType == 1 || playingStatusType == 0"
        />
      </div>
      <div class="audio-control-button-prev" @click="changeChapter(0)">
        <img src="./img/prev.png" alt="" />
      </div>
      <div
        class="audio-control-play"
        :class="{
          pause: playing && !audioLoading,
          loading: clickPlay && audioLoading,
        }"
        @click="play"
      ></div>
      <div class="audio-control-button-next" @click="changeChapter(1)">
        <img src="./img/prev.png" alt="" />
      </div>
      <!-- <div class="audio-control-button-speed" @click="showToast">
        <img src="./img/speed.png" alt="">
      </div> -->
    </div>
    <div
      class="audio-control-speed"
      v-if="!speedVisible"
      @click="speedVisible = !speedVisible"
    >
      <div class="audio-control-speed-main">
        <ul class="audio-control-speed-main-list">
          <li
            v-for="(item, index) in speedList"
            :key="index"
            @click="choseSpeed(item, index)"
          >
            <span>{{ item }}X</span>
            <span :class="{ checked: index === speedIndex }"></span>
          </li>
        </ul>
        <div
          class="audio-control-speed-close"
          @click="speedVisible = !speedVisible"
        >
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 补0

import formatSeconds from "../../../filters/format-seconds-2";
import { downloadApp } from "@mixins";
import os from "@edu-fe/os";

const double = (value) => (value < 10 ? "0" : "") + value;

export default {
  props: [
    "currentTime", // 当前时间
    "buffered", // 缓冲时间
    "duration", // 总时长
    "playing", // 正在播放
    "showFull", // 是否展示全屏按钮
    "show", // 是否展示控制条
    "live", // 是否是直播
    "isAudio", // 是否是音频
    "isTimerRight",
    "audioLoading", //音频加载中
    "clickPlay",
    "title",
    "hasBuy",
    "isSeepWidth", // 是否到了最后
    "playingStatusType", // 当前播放状态类型
    "switchPlayingStatusType", // 切换播放类型
  ],
  data() {
    return {
      timer: -1, // 显示倒计时
      touching: false, // 正在触摸时间条
      touchPercent: 0, // 正在触摸时进度百分比
      touchTime: 0, // 正在触摸时的时间长度
      showMain: true, // 是否展示控制条
      showMainTimer: -1, // 展示控制条定时器
      showMainInterval: 2500, // 控制条展示时间
      speedList: ["0.75", "1.0", "1.25", "1.5", "2.0"],
      speedIndex: -1,
      speedVisible: true,
      speedShowTime: false,
    };
  },
  computed: {
    // 缓冲条长度百分比
    bufferedPercent() {
      if (!this.duration) return 0;
      return (
        Math.min(100, Math.round((this.buffered / this.duration) * 100)) + "%"
      );
    },
    // 播放进度百分比
    currentPercent() {
      if (!this.duration) return 0;
      if (this.touchPercent) return this.touchPercent * 100 + "%";
      return (
        Math.min(100, Math.round((this.currentTime / this.duration) * 100)) +
        "%"
      );
    },
    isWeixin() {
      return os.type === "weixin";
    },
  },
  mixins: [downloadApp],
  methods: {
    showToast() {
      this.$toast.show({
        message: "此功能限App使用，即将跳转下载...",
      });
      setTimeout(() => {
        this.download("");
      }, 500);
    },
    changeChapter(index) {
      this.$emit("changeChapter", index);
    },
    choseSpeed(item, index) {
      this.speedIndex = index;
      this.$emit("speedChange", item);
    },
    formatSeconds: (seconds) => formatSeconds(seconds),
    // 播放按钮点击
    play() {
      this.$emit("play");
    },
    // 全屏点击
    fullscreen() {
      this.$emit("full");
      this.showControl();
    },
    // 获取进度条相关数据
    getLine(event) {
      let clientX = event.clientX;
      if (event.touches && event.touches.length) {
        clientX = event.touches[0].pageX;
      }

      const line = this.$refs.line;

      const bound = line.getBoundingClientRect();

      let percent = (clientX - bound.left) / bound.width;
      if (percent > 1) {
        percent = 1;
      } else if (percent < 0) {
        percent = 0;
      }

      let time = percent * this.duration;

      return {
        clientX,
        line,
        bound,
        percent,
        time,
      };
    },
    // 播放条拖动1
    touchstart(event) {
      event.stopPropagation();
      if (this.live) {
        return false;
      }
      const line = this.getLine(event);
      this.touching = true;
      this.touchPercent = line.percent;
      this.touchTime = line.time;
      this.currentTime = line.time;

      this.showControl(false);
    },
    // 播放条拖动2
    touchmove(event) {
      event.stopPropagation();
      this.speedShowTime = true;
      if (this.touching) {
        const line = this.getLine(event);
        this.touchPercent = line.percent;
        this.touchTime = line.time;

        this.currentTime = line.time;
      }
    },
    // 播放条拖动3
    touchend(event) {
      event.stopPropagation();
      this.speedShowTime = false;
      if (this.touching) {
        this.$emit("seek", {
          time: this.touchTime,
        });
        this.touching = false;
        this.touchPercent = 0;
        this.touchTime = 0;

        this.showControl();
      }
    },
    // 遮罩点击
    coverClick() {
      this.showControl();
    },
    // 显示控制条(是否一段时间后隐藏, 默认是)
    showControl(ifHideLater = true) {
      this.showMain = true;
      clearTimeout(this.showMainTimer);
      if (ifHideLater && !this.isAudio) {
        // 播放音频时不隐藏播放条
        this.showMainTimer = setTimeout(() => {
          this.showMain = false;
        }, this.showMainInterval);
      }
    },
    hideControl() {
      this.showMain = false;
      clearTimeout(this.showMainTimer);
    },
  },
  filters: {
    // 时间过滤器
    time(value) {
      let second = double(parseInt(value % 60));
      let minute = double(parseInt(value / 60));
      if (isNaN(second)) second = "00";
      if (isNaN(minute)) minute = "00";
      return `${minute}:${second}`;
    },
  },
  mounted() {
    console.log("isSeepWidth", this.isSeepWidth);
    this.speedShowTime = false;
    this.showControl();
  },
};
</script>

<style lang="scss">
@charset "utf-8";
@import "../../../style/main";

$global-width: 750;

.audio-control {
  // @include afull();
  /*z-index: 5;*/
  /*width: rem(690);*/
  /*height: rem(280);*/
  &-speed {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background-color: rgba(#000, 0.4);
    font-size: rem(30);
    font-weight: bold;
    color: #333333;
    &-close {
      text-align: center;
      padding-top: rem(30);
    }
    &-main {
      width: 100%;
      height: rem(604);
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #fff;
      &-list {
        padding: 0 rem(30);
        .checked {
          background: #f79900;
        }
        > li {
          padding: rem(29) 0;
          border-bottom: 1px solid #f3f4f5;
          display: flex;
          align-items: center;
          justify-content: space-between;
          > span {
            line-height: 1.4;
            &:last-child {
              display: inline-block;
              width: rem(28);
              height: rem(28);
              border-radius: 100%;
              border: 1px solid #d7d7d7;
            }
          }
        }
      }
    }
  }
  &-title {
    width: rem(570);
    font-size: rem(38);
    color: #fff;
    font-weight: bolder;
    text-align: center;
    padding-top: rem(37);
    line-height: 1.4;
    margin: auto auto rem(60);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-desc {
    line-height: 1.4;
    color: #f48f00;
    font-size: rem(24);
    text-align: center;
    margin-bottom: rem(20);
  }
  &-button {
    position: relative;
    width: rem(354);
    height: rem(150);
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-loop {
      position: absolute;

      img {
        position: absolute;
        left: rem(-100);
        top: 0;
        bottom: 0;
        margin: auto;
      }
      .list-loop {
        width: rem(40);
        height: rem(27);
      }
      .odd-loop,
      .order-play {
        width: rem(38);
        height: rem(38);
      }
    }
    &-prev,
    &-next {
      width: rem(29);
      height: rem(38);
      img {
        width: 100%;
      }
    }
    &-next {
      transform: rotate(180deg);
    }
    &-speed {
      position: absolute;
      color: #999999;
      width: rem(37);
      right: rem(-130);
      > img {
        width: 100%;
      }
    }
  }
  &-cover {
    @include afull();
  }

  &-main {
    // @include absolute("blw");
    // @include height(rem(76));
    text-align: center;
    & > div {
      display: inline-block;
      vertical-align: middle;
    }
  }
  &-play {
    // @include square(rem(76));
    position: relative;
    width: rem(50);
    height: rem(64);
    background: {
      image: url("./img/play.png");
      size: contain;
      repeat: no-repeat;
    }
    // &:before {
    //   content: "";
    //   display: block;
    //   @include atl(rem(23), rem(28));
    //   @include square(rem(25), rem(28.5));
    //   background-size: 100% 100%;
    //   background-image: url("./img/play.png?__inline");
    // }
    /*&.loading {*/
    /*overflow: hidden;*/
    /*&:before {*/
    /*content: '加载中..';*/
    /*display: inline;*/
    /*font-size: rem(14);*/
    /*line-height: rem(64);*/
    /*color: #fff;*/
    /*}*/
    /*background: #f48f00;*/
    /*border-radius: 100%;*/
    /*text-align: center;*/
    /*}*/
    &.pause {
      background: {
        image: url("./img/pause.png");
        size: contain;
        repeat: no-repeat;
      }
    }
  }
  &-pause {
    &:before {
      // @include square(rem(26), rem(34));
      background-image: url("./img/pause.png?__inline");
    }
  }
  &-line {
    width: 100%;
    /*line-height: rem(15);*/
    /*height: rem(15);*/
    &-box {
      @include square(100%, rem(8));
      // margin-top: rem(34);
      /*margin-left: rem(6);*/
      height: rem(6);
      // background-color: #fff;
      background-color: rgba(#ffffff, 0.36);
      border-radius: rem(3);
      position: relative;
    }

    &-buffered {
      display: block;
      @include absolute("tlwh");
      // background-color: rgba(#1c1c1c, 0.3);
      border-radius: rem(3);
    }

    // 已听进度条
    &-current {
      @include absolute("tlwh");
      display: block;
      width: 100%;
      height: rem(4);
      border-radius: rem(3);
      background-color: #fff;

      // 播放进度控制按钮
    }
    & .timer {
      position: absolute;
      padding: 0 rem(10);
      line-height: rem(37);
      top: 50%;
      transform: translateY(-50%);
      color: #1c1c1c;
      background: #fff;
      text-align: center;
      border-radius: rem(19);
      // margin-left: rem(-50);
      // &:not(.flr) {
      //   left: 0;
      // }
      // &.flr {
      //   // float: right;
      //   right: 0;
      // }

      .show-current-time {
        position: absolute;
        top: rem(-80);
        left: rem(-65);
        font-size: rem(40);
        color: #fff;
        line-height: rem(64);
        background: #0662c9;
        border-radius: 32px;
        padding: 0 rem(20);
      }
    }
  }

  &-time {
    width: rem(690);
    font-size: rem(20);
    height: rem(31);
    margin: auto auto rem(20);
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-fullscreen {
    @include square(rem(76));
    position: relative;
    &:before {
      content: "";
      display: block;
      @include atl(rem(23), rem(28));
      @include square(rem(25), rem(28.5));
      background-size: 100% 100%;
      background-image: url("./img/fullscreen.png?__inline");
    }
  }
}

.initalDistance {
  left: rem(50);
}

$global-width: 720;
</style>
